import Swal, { SweetAlertResult } from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

export const showSuccessAlert = (title: string) => {
  withReactContent(Swal).fire({
    title: title,
    icon: "success",
    confirmButtonColor: "blueviolet",
  });
};

export const showErrorAlert = (title: string) => {
  withReactContent(Swal).fire({
    title: title,
    icon: "error",
    confirmButtonColor: "blueviolet",
  });
};

export const showEditWarning = (
  title: string,
  setter: React.Dispatch<React.SetStateAction<boolean>>
) => {
  withReactContent(Swal)
    .fire({
      showCancelButton: true,
      confirmButtonText: "Yes ",
      confirmButtonColor: "blueviolet",

      title: title,
      icon: "warning",
    })
    .then((res: SweetAlertResult<any>) => {
      setter(res.isConfirmed);
    });
};

export const showWarningAlert = (title: string) => {
  withReactContent(Swal).fire({
    title: title,
    icon: "warning",
    confirmButtonColor: "blueviolet",
  });
};
